/**
 * Central route map for the site. Internal links use these so the original
 * Webflow .html targets become clean Next.js routes in one place.
 */
export const routes = {
    home: '/',
    features: '/features',
    company: '/company',
    pricing: '/pricing',
    contact: '/contact',
    support: '/support',
    blog: '/blog',
    privacy: '/privacy',
    search: '/search',
    notFound: '/404',
    blogPost: (slug: string): string => `/blog/${slug}`,
    blogCategory: (slug: string): string => `/blog/category/${slug}`,
    supportArticle: (slug: string): string => `/support/${slug}`
} as const
